<template>
    <div>
        <div class="card" v-if="sesion">
            <div class="card-header">
                <div class="text-center text-lg-left">
                    <div class="d-md-flex justify-content-md-between">
                        <h3 class="card-title my-3">
                            Cupones para la sesión: {{ sesion.fecha }}
                        </h3>
                        <div>
                            <Button
                                class="m-1"
                                id="nuevo-cupon"
                                @click="showModal('CreateVoucher')"
                            >Nuevo cupón</Button>
                            <CreateVoucher
                                :session_id="session_id"
                                :event_id="event_id"
                                v-on:close="closeModal"
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div class="card-body">
                <div class="row">
                    <div class="col-12">
                        <template v-for="(voucher, index) in voucher_codes">
                            <div class="row mb-4" :key="index">
                                <div class="col-6 col-md-10">
                                    <div class="row">
                                        <div class="col-12 col-md-6">
                                            <div class="row">
                                                <div class="col-12 col-md-6">
                                                    <strong>{{
                                                        voucher.name
                                                    }}</strong>
                                                </div>
                                                <div class="col-12 col-md-6">
                                                    <i
                                                        class="text-green fas fa-barcode mr-2"
                                                    ></i>{{ voucher.code }}
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-md-6">
                                            <div class="row">
                                                <div class="col-12 col-md-4">
                                                    <i
                                                        class="text-green fas fa-percent mr-2"
                                                    ></i>{{
                                                        voucher.discount_percent
                                                    }}
                                                </div>
                                                <div class="col-12 col-md-4">
                                                    <i
                                                        class="text-green fas fa-euro-sign mr-2"
                                                    ></i>{{
                                                        voucher.discount_fixed
                                                    }}
                                                </div>
                                                <div class="col-12 col-md-4">
                                                    <i
                                                        class="text-green fas fa-user mr-2"
                                                    ></i>{{ voucher.units }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-6 col-md-2">
                                    <OpcionesDropdownComponent
                                        v-bind:options="[
                                            {
                                                type: 'action',
                                                action: () =>
                                                    showModal(
                                                        'UpdateVoucher-' +
                                                            voucher.id
                                                    ),
                                                label: 'Editar',
                                            },
                                            {
                                                type: 'action',
                                                action: () =>
                                                    showModal(
                                                        'DeleteVoucher-' +
                                                            voucher.id
                                                    ),
                                                label: 'Borrar',
                                            },
                                        ]"
                                    />
                                </div>
                                <EditarModal
                                    :event_id="event_id"
                                    :session_id="session_id"
                                    :voucher="voucher"
                                    v-on:close="closeModal"
                                />
                                <BorrarModal
                                    :event_id="event_id"
                                    :session_id="session_id"
                                    :voucher="voucher"
                                    v-on:close="closeModal"
                                />
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </div>

        <div
            class="card card-primary card-outline card-outline-tabs"
            v-if="sesion"
        >
            <div class="card-header">
                <h3 class="card-title my-3">Configuración de cupones</h3>
                <div class="row justify-content-end">
                    <Button @click="$refs.voucherRegionTableComponent.updateAllRegions()">Guardar Todos</Button>
                </div>
            </div>
            <div>
                
            </div>
            <div class="card-body" v-if="!loading">
                <div class="tab-content">
                    <div class="tab-pane fade active show">
                        <transition name="fade" mode="out-in">
                            <div class="overlay-wrapper">
                                <VoucherRegionTableComponent
                                    :event_id="event_id"
                                    :session_id="session_id"
                                    v-bind:vouchers="voucher_codes"
                                    ref="voucherRegionTableComponent"
                                />
                            </div>
                        </transition>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CreateVoucher from './../../modals/CreateVoucher'
    import EditarModal from './../../modals/UpdateVoucher'
    import BorrarModal from './../../modals/DeleteVoucher'
    import OpcionesDropdownComponent from '@/components/backend/components/OpcionesDropdownComponent'
    import VoucherRegionTableComponent from '@/components/backend/eventos/VoucherRegionTableComponent'

    export default {
        props: ['event_id', 'session_id'],
        data() {
            return {
                sesion: null,
                voucher_codes: [],
                loading: false,
            }
        },
        created() {
            this.getSesion()
            this.getVouchers()
        },
        methods: {
            getVouchers() {
                this.loading = true

                const params = {
                    filters: {},
                    event_id: this.event_id,
                    session_id: this.session_id,
                }

                this.$store
                    .dispatch(
                        this.config.getVuexAlias('back.events.voucher.index'),
                        params
                    )
                    .then(res => {
                        this.voucher_codes = res.data.data
                    })
                    .finally(() => (this.loading = false))
            },
            getSesion() {
                this.loading = true

                const params = {
                    filters: {},
                    evento_id: this.event_id,
                    sesion_id: this.session_id,
                }

                this.$store
                    .dispatch(
                        this.config.getVuexAlias('back.events.sesiones.show'),
                        params
                    )
                    .then(res => {
                        this.sesion = res.data.data
                        this.entradas = res.data.data.entradas
                    })
                    .finally(() => (this.loading = false))
            },
            showModal(modal) {
                this.$modal.show(modal)
            },
            closeModal(modal, editado) {
                if (editado) this.getVouchers()
                this.$modal.hide(modal)
            },
        },
        components: {
            CreateVoucher,
            EditarModal,
            BorrarModal,
            OpcionesDropdownComponent,
            VoucherRegionTableComponent,
        },
    }
</script>
